export default __webpack_public_path__ + "static/media/home-component-markdown.173c5c14.md";